import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

import { ConfigProvider, Empty, App as AntdApp } from "antd";
import locale from "antd/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/ru";

import theme from "./theme";
import "./index.css";

import reportWebVitals from "./reportWebVitals";

dayjs.locale("ru");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <ConfigProvider
        theme={{ token: theme.token, components: theme.components }}
        locale={locale}
        renderEmpty={() => (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Нет данных"
          />
        )}
      >
        <AntdApp>
          <App />
        </AntdApp>
      </ConfigProvider>
    </Router>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
